/*
	  $$$\                                               $$$\   
	 $$  _|                                              \_$$\  
	 $$ |        $$$$$$\$$$$\   $$$$$$\   $$$$$$\          $$ | 
	$$$ |        $$  _$$  _$$\  \____$$\ $$  __$$\         $$$\ 
	\$$ |        $$ / $$ / $$ | $$$$$$$ |$$ /  $$ |        $$  |
	 $$ |        $$ | $$ | $$ |$$  __$$ |$$ |  $$ |        $$ / 
	 \$$$\       $$ | $$ | $$ |\$$$$$$$ |$$$$$$$  |      $$$  | 
	  \___|      \__| \__| \__| \_______|$$  ____/       \___/  
										 $$ |                   
										 $$ |                   
										 \__|                   
*/

(function() {
	'use strict';
	/*global L,daum */

	L.DynamicDivIcon = L.DivIcon.extend({
		options: {
			iconSize: null,
			iconAnchor: null,
			// get className() {
			// 	return this.originalClassName + (this.selected ? ' selected':'') + (this.searched ? ' searched':'') + (this.highlighted? ' highlighted':'');
			// },
			originalClassName: 'leaflet-dynamic-div-icon',
			selected: false,
			highlighted: false,
			searched: false,
		},

		initialize: function (options){
			L.setOptions(this, options);
			Object.defineProperty(this.options, 'className', { 
				get: function () { 
					return this.originalClassName + (this.selected ? ' selected':'') + (this.searched ? ' searched':'') + (this.highlighted? ' highlighted':'');
				} 
			});
		}
	});
	L.dynamicDivIcon = function (options) {
		return new L.DynamicDivIcon(options);
	};

	try{
		var geocoder = new daum.maps.services.Geocoder();
	}catch(error){
		var geocoder = null;
	}

	angular.module('hhv.map', [])
		.factory('HvGeocoder', ['$log', '$q', function($log, $q){
			try{
				var geocoder = new daum.maps.services.Geocoder();
			}catch(error){
				$log.error('No Daum Maps Api');
				var geocoder = null;
			}

			var service = {};
			service.addr2coord = addr2coord;
			return service;

			function addr2coord(address){
				$log.debug('looking for ' + address);
				var promise = $q(function(resolve, reject){
					geocoder.addr2coord(address, function(status, result){
						if (status === daum.maps.services.Status.OK) {
							var latlng = {
								lat: result.addr[0].lat,
								lng: result.addr[0].lng
							};
							resolve(latlng);
						}else{
							$log.warn(status);
							reject(status);
						}
					});
				})
				.then(function(data){
					angular.extend(promise, data);
					return data;
				});
				return promise;
			}
		}])
		.directive('hvMap', ['$compile', '$filter', '$location', '$state', function($compile, $filter, $location, $state){
		// Runs during compile
		return {
			// name: '',
			// priority: 1,
			// terminal: true,
			scope: {
			  markers: '=',
			  selected: '=',
			  searched: '=',
			  center: '=',
			  zoom: '@',
			  events: '@',
			  hashing: '@',
			  clustering: '@',
			  //interactive options 
			  scrollWheelZoom: '@',
			  //events callback
			  markerOver: '&',
			  markerLeave: '&'
			},
			// require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
			restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
			// transclude: true,
			// compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
			link: function postLink($scope, iElm, iAttrs, controller) {
				var container = iElm[0]; 
				var markersList = {};
				var searchedMarkers = [];
				var highlightedMarkers = [];

				var daumCrs = new L.Proj.CRS('EPSG:5181',
				    '+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
				    {
						resolutions: [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25],
						origin: [-30000, -60000],
						bounds: L.bounds([-30000, -60000], [494288, 988576])
				    });

				//var baseLayer = new L.TileLayer.Provider('DaumMap.Street');
				var baseLayer = new L.TileLayer('http://mi512.maps.daum-img.net/map/mobile512/G03/hdi/var2201/L{z}/{y}/{x}.png', {
									maxZoom: 13,
									minZoom: 0,
									zoomOffset: 1,
									zoomReverse: true,
									subdomains: '0123',
									continuousWorld: true,
									attribution: 'Map data &copy; <a href="http://map.daum.net/">DaumMap</a>',
									tms: true
								});
				/*global HeatmapOverlay*/
				var heatLayer = new HeatmapOverlay({'radius': 50, 'maxOpacity': 0.5, latField: 'geolatitude', lngField: 'geolongitude'});
				var locationSearch = $location.search();
				var map = L.map(container, 
					{
						crs: daumCrs,
						layers: [baseLayer],
						center: [locationSearch.x || 37.55936401436028, locationSearch.y || 126.92271666470043],		//HHV
						zoom: $scope.zoom || 9,
						minZoom: 4,
						maxZoom: 12,
						zoomControl: false,
					});
				new L.Control.Zoom({ position: 'topright' }).addTo(map);

				var defaultClusterOptions = { 
					animateAddingMarkers : true,
					spiderfyDistanceMultiplier: 1.5,
					spiderfyOnMaxZoom: false,
					zoomToBoundsOnClick : false,
					chunkedLoading: true,
					chunkInterval: 100,
					maxClusterRadius: function(zoom){
						return 30*map.getMaxZoom()/zoom;
					},
					iconCreateFunction: function(cluster){
						var childCount = cluster.getChildCount();
						var children = cluster.getAllChildMarkers();
						var searchedCount = 0;
						var selectedCount = 0;
						var zIndexOffset = 0;
						for (var i = children.length - 1; i >= 0; i--) {
							var child = children[i];

							if(child.data.searched)
								searchedCount++;
							if(child.data.selected)
								selectedCount++;

							zIndexOffset += child.options.zIndexOffset;
						}
						//cluster.setZIndexOffset(zIndexOffset);

						var c = ' marker-cluster-';
						if (childCount < 10) {
							c += 'small';
						} else if (childCount < 100) {
							c += 'medium';
						} else {
							c += 'large';
						}
						if (selectedCount > 0) 
							c += ' selected';

						var html = '<div><span>' +
									childCount +
									'</span></div>';
						if(searchedCount > 0){
							c += ' searched';
							html = '<div class="total"><span>' +
									childCount +
									'</span></div>' +
									'<div class="searched"><span>' +
									searchedCount +
									'</span></div>';
						}

						//$filter('orderObjectBy')(children, ['data.tempSelected', 'data.selected', 'data.searched']);

						var popupHtml = '<ul><li ng-repeat="marker in children | orderObjectBy:[\'data.tempSelected\', \'data.selected\', \'data.searched\' ] track by marker.data.id | limitTo:10" ng-init="org = marker.data" ng-class="{searched: org.searched, selected: org.selected, highlighted: org.highlighted, \'temp-selected\': org.tempSelected}"><a href="{{ $root.$state.href(\'.detail\', {org: org.id}) || $root.$state.href(\'^.detail\', {org: org.id}) }}" itemprop="url" ng-mouseover="markerOver({event:{layer: marker}});" ng-mouseleave="markerLeave({event:{layer: marker}});">{{org.name}}</a></li></ul>';

						cluster.bindPopup(popupHtml, {
							offset: [0, -5], 
							autoPan: false,
							autoPanPaddingTopLeft: [parseFloat(iElm.css('padding-left')), parseFloat(iElm.css('padding-top'))],
							autoPanPaddingBottomRight: [parseFloat(iElm.css('padding-right')), parseFloat(iElm.css('padding-bottom'))],
							minWidth: 180,
							maxHeight: 100,
							scope: {
								children: children
							}
						});

						return new L.DivIcon({ html: html, className: 'marker-cluster' + c, iconSize: null, iconAnchor: null});
					},

					polygonOptions: {
							color: '',
							weight: '',
							fillColor: '',
							className: 'cluster-convex'
						}
					};
				var searchedClusterOptions = angular.copy(defaultClusterOptions);
 				var searchedClusterMarkers = new L.MarkerClusterGroup(searchedClusterOptions);
				var clusterMarkers = new L.MarkerClusterGroup(defaultClusterOptions);
				var selectedMarkers = new L.featureGroup().addTo(clusterMarkers);
				var markerLayer = clusterMarkers;//L.featureGroup([clusterMarkers, selectedMarkers]);
				                                 //
								// add the EdgeMarker to the map.
				var edgeMarker = L.edgeMarker({
					distanceOpacity: true,
					icon: L.icon({ // style markers
						iconUrl: '/image/edge-arrow-marker-black.png',
						clickable: true,
						iconSize: [48, 48],
						iconAnchor: [24, 24]
			      	}),
				    rotateIcons: true, // rotate EdgeMarkers depending on their relative position
				    layerGroup: selectedMarkers // you can specify a certain L.layerGroup to create the edge markers from.
				    }).addTo(map);

				markerLayer.on('clusterclick', function onClusterclick(event) {
					event.originalEvent.stopPropagation();
					var bounds = event.layer.getBounds();
					map.fitBounds(bounds.pad(0.1),
						{
							paddingTopLeft: [parseFloat(iElm.css('padding-left')), parseFloat(iElm.css('padding-top'))],
							paddingBottomRight: [parseFloat(iElm.css('padding-right')), parseFloat(iElm.css('padding-bottom'))]
						});
				});
				markerLayer.on('clustermouseover', function onClustermouseover(event){
					var c = event.layer;
					var children = c.getAllChildMarkers();
					for (var i = children.length - 1; i >= 0; i--) {
						var m = children[i];
					}

					$scope.$applyAsync();
					var popup = c.getPopup();
					if(!popup.isOpen()) c.openPopup();

					// c.once('mouseout', function(event){
					// 	c.closePopup();
					// 	$scope.$applyAsync();

					// });
				});
				markerLayer.on('mouseover', function onMouseover(event){
					if($scope.markerOver)
						$scope.markerOver({
							event: event
						});
				});
				markerLayer.on('mouseout', function onMouseout(event){
					if($scope.markerLeave)
						$scope.markerLeave({
							event: event
						});
				});
				markerLayer.on('click', function onClick(event){
					var m = event.layer;
					if(m.data.selected)
						return false;
					//$location.path('@'+m.data.name);
					if($state.includes('**.detail.**'))
						$state.go('^.detail', {org: m.data.id});
					else 
						$state.go('.detail', {org: m.data.id});
					$scope.$applyAsync();
				});

				map.on('popupopen', function onPopupopen(event) {
					var popup = event.popup;
					var popupScope = $scope.$new();
					if(popup.options.scope)
						angular.extend(popupScope, popup.options.scope);
					$compile(popup._contentNode)(popupScope);
				});

				map.on('popupclose', function onPopupclose(event) {
					var popup = event.popup;
					var popupScope = $scope.$new();
					if(popup.options.scope)
						for (var i = popup.options.scope.children.length - 1; i >= 0; i--) {
							var org = popup.options.scope.children[i].data;
							if(org.highlighted) delete org.highlighted;
						}
					$scope.$applyAsync();
				});


				map.addLayer(markerLayer);

				$scope.$watchGroup(['center', 'zoom'], function handleFitting(newValues, oldValues, scope) {
					if(typeof newValues[1] === 'string' && newValues[1].toLowerCase() === 'max')
						newValues[1] = map.getMaxZoom();
					var center = (newValues[0]&&newValues[0][0]&&newValues[0][1]) ? L.latLng(newValues[0]) : map.getCenter();
					var zoom = Number(newValues[1]) || map.getZoom();
					if(!center.equals(map.getCenter()) || zoom != map.getZoom()){
						map.flyTo(center, zoom);
					}
				}, true);

				///hashing
				$scope.$watch('hashing', function(newValue, oldValue, scope) {
					var hashHandler;
					if(newValue) {
						hashHandler = map.on('moveend', function hashHandler(event){
							var latLng = map.getCenter();
							$location.search({
								x: latLng.lat,
								y: latLng.lng,
								z: map.getZoom()
							});
							$scope.$applyAsync();
						});
					}
					else {
						if(hashHandler) map.off(hashHandler); ///TODO: proper hashhandler removal
					}
				});

				$scope.$watch('scrollWheelZoom', function(newValue, oldValue, scope) {
					if(!newValue) 
						return false;
					if(newValue.toLowerCase() == 'false' || !!!newValue) 
						map.scrollWheelZoom.disable();
					else 
						map.scrollWheelZoom.enable();
				});

				$scope.$watch('clustering', function(newValue, oldValue, scope) {
					// if(newValue == null) return false;
					// if(!!!newValue) map.scrollWheelZoom.disable();
					// else map.scrollWheelZoom.enable();
				});

				$scope.$watch('markers', function handleMarkers(newValue, oldValue, scope) {
					if(!newValue) return;

					for (var i in newValue) {
						var org = newValue[i];
						var oldOrg = oldValue? oldValue[i]:undefined;
						var m;
						if(!org)
							continue;
						if(markersList[org.id])
							m = markersList[org.id];
						else {
							var latlng = [parseFloat(org.lat || org.latitude), parseFloat(org.lng || org.longitude)];
							if( isNaN(latlng[0])|| isNaN(latlng[1]) )
								break;
							m = markersList[org.id] = L.marker(latlng, {
								icon: L.dynamicDivIcon({originalClassName:'icn-numbered'}),
								title: org.name,
							});
							m.data = org;
						}

						var isSelected = org.selected || org.tempSelected;
						var cluster;
						var popup;
						var layerGroup = clusterMarkers;
						if(isSelected){
							cluster = clusterMarkers.getVisibleParent(m);
							//m.addTo(selectedMarkers);
							m.options.icon.options.selected = true;
							m.setZIndexOffset(10000);
							
							if(false && !map.getBounds().contains(m.getLatLng())){

								map.fitBounds(
									[m.getLatLng(), m.getLatLng()], 
									{
										paddingTopLeft: [parseFloat(iElm.css('padding-left')), parseFloat(iElm.css('padding-top'))],
										paddingBottomRight: [parseFloat(iElm.css('padding-right')), parseFloat(iElm.css('padding-bottom'))],
										maxZoom: map.getZoom()
									}
								);
							}else{

							}

							if(cluster) {
								popup = cluster.getPopup();
								if(popup && !popup.isOpen() && !oldOrg.selected) 
									cluster.openPopup();
								
							}
						}else if(!isSelected && m.options.icon.options.selected){
							cluster = clusterMarkers.getVisibleParent(m);
							m.options.icon.options.selected = false;
							
							if(cluster){
								popup = cluster.getPopup();
								if(popup && popup.isOpen && popup.isOpen()) {
									map.closePopup();
									console.log('close popup');
								}
							}
						}

						if(m.data.searched){
							m.options.icon.options.searched = true;
						}else{
							m.options.icon.options.searched = false;
						}

						m.refreshIconOptions(); 
					}
					var markersArray = Object.keys(markersList).map(function (key) {return markersList[key];});
					clusterMarkers.addLayers(markersArray);
					clusterMarkers.refreshClusters();
				}, true);
				$scope.$parent.map = map;
			}
		};
	}]);

})();